export default __webpack_public_path__ + "static/media/biboo.928ff2d4.png";